import { FC } from "react";

interface MainContentProps {
	fullHeight?: boolean;
	children: React.ReactNode;
	isVisible: boolean; // Add this line
}

const MainContent: FC<MainContentProps> = ({
	fullHeight,
	children,
	isVisible, // Add this line
}: MainContentProps) => {
	return (
		<div
			className={`${
				fullHeight
					? isVisible
						? "h-[68vh]"
						: "h-[80vh]"
					: isVisible
					? "h-[58vh]"
					: "h-[65vh]"
			} px-[2%] py-[2vh] overflow-y-auto`}
		>
			{children}
		</div>
	);
};

export default MainContent;
